export const slugsPart6 = {
    "T-Mobile": "tmobile",
    "Tableau": "tableau",
    "Taco Bell": "tacobell",
    "Tails": "tails",
    "Tailwind CSS": "tailwindcss",
    "Talend": "talend",
    "Talenthouse": "talenthouse",
    "Tamagui": "tamagui",
    "Tampermonkey": "tampermonkey",
    "Taobao": "taobao",
    "Tapas": "tapas",
    "Target": "target",
    "Task": "task",
    "Tasmota": "tasmota",
    "Tata": "tata",
    "Tauri": "tauri",
    "TaxBuzz": "taxbuzz",
    "TeamCity": "teamcity",
    "Teamspeak": "teamspeak",
    "TeamViewer": "teamviewer",
    "Ted": "ted",
    "TeeSpring": "teespring",
    "Tekton": "tekton",
    "Tele5": "tele5",
    "Telegram": "telegram",
    "Telegraph": "telegraph",
    "Tencent QQ": "tencentqq",
    "Tenor": "tenor",
    "TensorFlow": "tensorflow",
    "Teradata": "teradata",
    "Teratail": "teratail",
    "Terraform": "terraform",
    "Tesco": "tesco",
    "Tesla": "tesla",
    "Testing Library": "testinglibrary",
    "Teta": "teta",
    "Tether": "tether",
    "TextPattern": "textpattern",
    "TGI Fridays": "tgifridays",
    "The Conversation": "theconversation",
    "The Mighty": "themighty",
    "The Models Resource": "themodelsresource",
    "The Movie Database": "themoviedatabase",
    "The North Face": "thenorthface",
    "The Register": "theregister",
    "The Sounds Resource": "thesoundsresource",
    "The Spriters Resource": "thespritersresource",
    "The Washington Post": "thewashingtonpost",
    "The Weather Channel": "theweatherchannel",
    "Theia": "theia",
    "ThinkPad": "thinkpad",
    "Threadless": "threadless",
    "Threads": "threads",
    "Threema": "threema",
    "Thumbtack": "thumbtack",
    "Thunderbird": "thunderbird",
    "Thurgau Kantonalbank": "thurgaukantonalbank",
    "Thymeleaf": "thymeleaf",
    "Ticketmaster": "ticketmaster",
    "Tidal": "tidal",
    "Tide": "tide",
    "Tier": "tier",
    "TikTok": "tiktok",
    "Tile": "tile",
    "Tilt": "tilt",
    "Timeular": "timeular",
    "Timiv": "timiv",
    "Tinder": "tinder",
    "Tindie": "tindie",
    "Tinkoff": "tinkoff",
    "TinyMCE": "tinymce",
    "Tiz": "tiz",
    "Tizen": "tizen",
    "Todoist": "todoist",
    "Toggl": "toggl",
    "Toggl Track": "toggltrack",
    "Tokopedia": "tokopedia",
    "Toml": "toml",
    "TomTom": "tomtom",
    "Tomorrowland": "tomorrowland",
    "Topcoder": "topcoder",
    "Toptal": "toptal",
    "Tor Browser": "torbrowser",
    "Tor Project": "torproject",
    "Toshiba": "toshiba",
    "Toyota": "toyota",
    "TP-Link": "tplink",
    "Tqdm": "tqdm",
    "Traefik Mesh": "traefikmesh",
    "Traefik Proxy": "traefikproxy",
    "Trailforks": "trailforks",
    "TrainerRoad": "trainerroad",
    "Trakt": "trakt",
    "Transavia": "transavia",
    "TransferWise": "transferwise",
    "Transport for Ireland": "transportforireland",
    "Transport for London": "transportforlondon",
    "Travis CI": "travisci",
    "Treehouse": "treehouse",
    "Trello": "trello",
    "Trend Micro": "trendmicro",
    "Treyarch": "treyarch",
    "Triller": "triller",
    "Trino": "trino",
    "Trip.com": "tripdotcom",
    "TripAdvisor": "tripadvisor",
    "Trivago": "trivago",
    "Trolley": "trolley",
    "Tron": "tron",
    "TrueNAS": "truenas",
    "Trulia": "trulia",
    "Trusted Shops": "trustedshops",
    "Trustpilot": "trustpilot",
    "TryHackMe": "tryhackme",
    "TryItOnline": "tryitonline",
    "Ts-Node": "tsnode",
    "Tubi": "tubi",
    "TUI": "tui",
    "Tumblr": "tumblr",
    "TuneIn": "tunein",
    "Turbo": "turbo",
    "TurboC": "turboc",
    "Turborepo": "turborepo",
    "Turbosquid": "turbosquid",
    "Turkish Airlines": "turkishairlines",
    "Tutanota": "tutanota",
    "TvTime": "tvtime",
    "Twilio": "twilio",
    "Twitch": "twitch",
    "Twitter": "twitter",
    "Twoo": "twoo",
    "Typeform": "typeform",
    "TypeScript": "typescript",
    "TYPO3": "typo3",
    "Uber": "uber",
    "Uber Eats": "ubereats",
    "Ubiquiti": "ubiquiti",
    "Ubisoft": "ubisoft",
    "uBlock Origin": "ublockorigin",
    "Ubuntu": "ubuntu",
    "Udacity": "udacity",
    "Udemy": "udemy",
    "Ufc": "ufc",
    "Uikit": "uikit",
    "Ulule": "ulule",
    "Umbraco": "umbraco",
    "Unacademy": "unacademy",
    "Under Armour": "underarmour",
    "Underscore.js": "underscore",
    "Unicode": "unicode",
    "Unilever": "unilever",
    "United Airlines": "unitedairlines",
    "Unity": "unity",
    "Unlicense": "unlicense",
    "Unraid": "unraid",
    "Unreal Engine": "unrealengine",
    "Unsplash": "unsplash",
    "Untangle": "untangle",
    "Untappd": "untappd",
    "UpCloud": "upcloud",
    "Uphold": "uphold",
    "Uploadcare": "uploadcare",
    "Upstash": "upstash",
    "Uptime Kuma": "uptimekuma",
    "UptimeRobot": "uptimerobot",
    "Upwork": "upwork",
    "Urban Dictionary": "urbandictionary",
    "USPS": "usps",
    "V": "v",
    "V2Ray": "v2ray",
    "Vaadin": "vaadin",
    "Vagrant": "vagrant",
    "Valve": "valve",
    "Vapor": "vapor",
    "Vault": "vault",
    "Vaultwarden": "vaultwarden",
    "Vauxhall": "vauxhall",
    "Vaze": "vaze",
    "Veeam": "veeam",
    "Veepee": "veepee",
    "Vega": "vega",
    "Vegeta": "vegeta",
    "Velib": "velib",
    "Venmo": "venmo",
    "Vercel": "vercel",
    "Verdaccio": "verdaccio",
    "Veritas": "veritas",
    "Verizon": "verizon",
    "Vexxhost": "vexxhost",
    "VFairs": "vfairs",
    "Viadeo": "viadeo",
    "Viber": "viber",
    "Vim": "vim",
    "Vimeo": "vimeo",
    "Vimm": "vimm",
    "Vivaldi": "vivaldi",
    "Vivino": "vivino",
    "VK": "vk",
    "VLC Media Player": "vlcmediaplayer",
    "VMware": "vmware",
    "Vodafone": "vodafone",
    "Voice": "voice",
    "Voip.ms": "voipdotms",
    "Volkswagen": "volkswagen",
    "Volvo": "volvo",
    "Vonage": "vonage",
    "Voodoo": "voodoo",
    "Vortex": "vortex",
    "Vox": "vox",
    "Vsco": "vsco",
    "Vscode": "vscode",
    "Vsphere": "vsphere",
    "Vue.js": "vuedotjs",
    "Vuetify": "vuetify",
    "Vulkan": "vulkan",
    "Vultr": "vultr",
    "W3C": "w3c",
    "Wagtail": "wagtail",
    "Wakatime": "wakatime",
    "Walkman": "walkman",
    "Wallabag": "wallabag",
    "Walmart": "walmart",
    "Wappalyzer": "wappalyzer",
    "Warner Bros.": "warnerbros",
    "Warp": "warp",
    "Wasm": "wasm",
    "Watchman": "watchman",
    "Waterfox": "waterfox",
    "Wattpad": "wattpad",
    "Wayfair": "wayfair",
    "Waze": "waze",
    "Wear OS": "wearos",
    "Weasyl": "weasyl",
    "Web3.jS": "web3dotjs",
    "WebAssembly": "webassembly",
    "WebAuthn": "webauthn",
    "Webcomponents.org": "webcomponentsdotorg",
    "WebDriverIO": "webdriverio",
    "Webflow": "webflow",
    "Webgl": "webgl",
    "Webhint": "webhint",
    "Weblate": "weblate",
    "Webmin": "webmin",
    "Webpack": "webpack",
    "Webrtc": "webrtc",
    "Webstorm": "webstorm",
    "WeChat": "wechat",
    "Wegame": "wegame",
    "Weights & Biases": "weightsandbiases",
    "Welcometothejungle": "welcometothejungle",
    "Wells Fargo": "wellsfargo",
    "Wemo": "wemo",
    "Wester Digital": "westerndigital",
    "Wetransfer": "wetransfer",
    "Whatsapp": "whatsapp",
    "When I Work": "wheniwork",
    "Wii": "wii",
    "Wii U": "wiiu",
    "Wikidata": "wikidata",
    "Wikihow": "wikihow",
    "Wikipedia": "wikipedia",
    "Wikiquote": "wikiquote",
    "Wikivoyage": "wikivoyage",
    "Willhaben": "willhaben",
    "Windows": "windows",
    "Windows 11": "windows11",
    "Windows 95": "windows95",
    "Windows Terminal": "windowsterminal",
    "Windows XP": "windowsxp",
    "Winmate": "winmate",
    "Winrar": "winrar",
    "Wipro": "wipro",
    "Wire": "wire",
    "WireGuard": "wireguard",
    "Wireshark": "wireshark",
    "Wise": "wise",
    "Wish": "wish",
    "Wistia": "wistia",
    "Wix": "wix",
    "Wizz Air": "wizzair",
    "Wolfram": "wolfram",
    "Wolfram Language": "wolframlanguage",
    "Wolfram Mathematica": "wolframmathematica",
    "WooCommerce": "woocommerce",
    "Woolworths": "woolworths",
    "Wordpress": "wordpress",
    "Workplace": "workplace",
    "World Health Organization": "worldhealthorganization",
    "Wp Engine": "wpengine",
    "Wp Rocket": "wprocket",
    "Write.as": "writeas",
    "Wrike": "wrike",
    "Wwwc": "wwwc",
    "X": "x",
    "X.Org": "xdotorg",
    "Xamarin": "xamarin",
    "Xampp": "xampp",
    "Xbox": "xbox",
    "Xcode": "xcode",
    "Xdadevelopers": "xdadevelopers",
    "Xero": "xero",
    "Xfce": "xfce",
    "Xiaomi": "xiaomi",
    "Xilinx": "xilinx",
    "Xing": "xing",
    "Xmpp": "xmpp",
    "Xo": "xo",
    "Xrp": "xrp",
    "Xsplit": "xsplit",
    "Xstate": "xstate",
    "Yahoo!": "yahoo",
    "Yamaha Motor Corporation": "yamahamotorcorporation",
    "Yammer": "yammer",
    "Yandex": "yandex",
    "Yarn": "yarn",
    "Ycombinator": "ycombinator",
    "Yelp": "yelp",
    "Yoast": "yoast",
    "Yolo": "yolo",
    "YourTravelMates": "yourtravelmates",
    "Youtube": "youtube",
    "Youtube Gaming": "youtubegaming",
    "Youtube Music": "youtubemusic",
    "Youtube Studio": "youtubestudio",
    "YubiKey": "yubikey",
    "Yum": "yum",
    "Z-Wave": "zwave",
    "Zalando": "zalando",
    "Zapier": "zapier",
    "Zara": "zara",
    "Zcool": "zcool",
    "Zebra Technologies": "zebratechnologies",
    "Zelle": "zelle",
    "Zend Framework": "zendframework",
    "Zendesk": "zendesk",
    "Zenn": "zenn",
    "Zenodo": "zenodo",
    "Zerodha": "zerodha",
    "Zerotier": "zerotier",
    "Zhihu": "zhihu",
    "Zig": "zig",
    "Zigbee": "zigbee",
    "Zillow": "zillow",
    "ZincSearch": "zincsearch",
    "Zingat": "zingat",
    "Zoom": "zoom",
    "Zorin": "zorin",
    "Zotero": "zotero",
    "Zulip": "zulip",
    "Zure": "zure",
    "Zyxel": "zyxel"
};
